// 📁 ortak/src/fatura-takip/src/pages/AdminPage.js
import React, { useEffect, useState } from "react";
import { db, auth } from "../firebaseConfig";
import {
  collection,
  addDoc,
  updateDoc,
  getDocs,
  deleteDoc,
  doc,
  Timestamp
} from "firebase/firestore";
import { createUserWithEmailAndPassword } from "firebase/auth";
import * as XLSX from "xlsx";

const AdminPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("123456");
  const [role, setRole] = useState("Kullanıcı");
  const [message, setMessage] = useState("");
  const [deactivateEmail, setDeactivateEmail] = useState("");
  const [plate, setPlate] = useState("");
  const [type, setType] = useState("");
  const [model, setModel] = useState("");
  const [facility, setFacility] = useState("");
  const [aciklama, setAciklama] = useState("");
  const [existingPlates, setExistingPlates] = useState([]);
  const [isNewPlate, setIsNewPlate] = useState(true);
  const [authEmail, setAuthEmail] = useState("");
  const [firms, setFirms] = useState([]);

  const handleDeleteAllLogins = async () => {
    const snapshot = await getDocs(collection(db, "logins"));
    const promises = snapshot.docs.map((docu) =>
      deleteDoc(doc(db, "logins", docu.id))
    );
    await Promise.all(promises);
    alert("✅ Tüm login kayıtları silindi.");
  };

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) setAuthEmail(user.email);
    });

    const fetchPlates = async () => {
      const snapshot = await getDocs(collection(db, "plates"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const sorted = data.sort((a, b) => a.plate.localeCompare(b.plate, "tr"));
      setExistingPlates(sorted);
    };

    const fetchFirms = async () => {
      const snapshot = await getDocs(collection(db, "firms"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const sorted = data.sort((a, b) =>
        a.firmaAdi.localeCompare(b.firmaAdi, "tr")
      );
      setFirms(sorted);
    };

    fetchPlates();
    fetchFirms();

    return () => unsubscribe();
  }, []);

  const handleCreate = async () => {
    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      await addDoc(collection(db, "users"), {
        uid: userCred.user.uid,
        email,
        role,
        active: true,
      });
      setMessage("✅ Kullanıcı başarıyla eklendi.");
      setEmail("");
    } catch (err) {
      setMessage("❌ Hata: " + err.message);
    }
  };

  const handleDeactivate = async () => {
    const snapshot = await getDocs(collection(db, "users"));
    const docToUpdate = snapshot.docs.find((doc) => doc.data().email === deactivateEmail);
    if (!docToUpdate) return setMessage("❌ Kullanıcı bulunamadı.");

    await updateDoc(doc(db, "users", docToUpdate.id), { active: false });
    setMessage("🚫 Kullanıcı pasif yapıldı.");
  };

  const handleAddOrUpdatePlate = async () => {
    if (!plate) return;
    const plateFormatted = plate.toUpperCase().replace(/\s+/g, "");
    const existing = existingPlates.find((p) => p.plate === plateFormatted);

    const newData = {
      plate: plateFormatted,
      aracCinsi: type,
      model,
      tesis: facility,
      aciklama,
      active: true,
      createdBy: authEmail,
      createdTime: Timestamp.now(),
    };

    if (existing) {
      await updateDoc(doc(db, "plates", existing.id), newData);
      setMessage("✅ Plaka güncellendi.");
    } else {
      await addDoc(collection(db, "plates"), newData);
      setMessage("✅ Plaka eklendi.");
    }

    setPlate("");
    setType("");
    setModel("");
    setFacility("");
    setAciklama("");
    setIsNewPlate(true);
  };

  const handlePlateSelect = (e) => {
    const selected = e.target.value;
    if (selected === "__new__") {
      setPlate("");
      setType("");
      setModel("");
      setFacility("");
      setAciklama("");
      setIsNewPlate(true);
    } else {
      setPlate(selected);
      setIsNewPlate(false);
      const found = existingPlates.find((p) => p.plate === selected);
      if (found) {
        setType(found.aracCinsi || "");
        setModel(found.model || "");
        setFacility(found.tesis || "");
        setAciklama(found.aciklama || "");
      }
    }
  };

  const handleExportPlatesToExcel = () => {
    const data = existingPlates.map(p => ({
      Plaka: p.plate,
      "Araç Cinsi": p.aracCinsi || "",
      Model: p.model || "",
      Tesis: p.tesis || "",
      Açıklama: p.aciklama || "",
      Aktif: p.active ? "✔️" : "❌",
      Oluşturan: p.createdBy || "",
      "Oluşturma Tarihi": p.createdTime?.toDate().toLocaleString("tr-TR") || ""
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Plakalar");
    XLSX.writeFile(wb, "plaka_listesi.xlsx");
  };

  const handleExportFirmsToExcel = () => {
    const data = firms.map(f => ({
      "Firma Adı": f.firmaAdi,
      "Vergi No": f.vergiNo,
      "Vergi Dairesi": f.vergiDairesi || "",
      "KDV Oranı": f.kdvOrani || "",
      Yetkili: f.yetkili || "",
      Telefon: f.telefon || "",
      İl: f.il || "",
      İlçe: f.ilce || "",
      Adres: f.adres || "",
      Açıklama: f.aciklama || "",
      Aktif: f.active ? "✔️" : "❌",
      "Oluşturan": f.createdBy || "",
      "Oluşturma Tarihi": f.createdAt?.toDate().toLocaleString("tr-TR") || "",
      "Güncelleyen": f.updatedBy || "",
      "Güncelleme Tarihi": f.updatedAt?.toDate().toLocaleString("tr-TR") || ""
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Firmalar");
    XLSX.writeFile(wb, "firma_listesi.xlsx");
  };

  return (
    <div style={{ padding: 20, maxWidth: 600, margin: "auto" }}>
      <h2>👤 Yeni Kullanıcı Oluştur</h2>
      <input placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
      <input type="password" placeholder="Şifre" value={password} onChange={(e) => setPassword(e.target.value)} style={inputStyle} />
      <select value={role} onChange={(e) => setRole(e.target.value)} style={inputStyle}>
        <option value="Yetkili">Yetkili</option>
        <option value="Kullanıcı">Kullanıcı</option>
        <option value="Oluşturucu">Oluşturucu</option>
      </select>
      <button onClick={handleCreate} style={buttonStyle}>Kullanıcı Oluştur</button>

      <h2 style={{ marginTop: 40 }}>🚫 Kullanıcıyı Pasif Yap</h2>
      <input placeholder="E-posta girin" value={deactivateEmail} onChange={(e) => setDeactivateEmail(e.target.value)} style={inputStyle} />
      <button onClick={handleDeactivate} style={buttonStyle}>Pasifleştir</button>

      <h2 style={{ marginTop: 40 }}>🚗 Plaka Ekle / Güncelle</h2>
      <select onChange={handlePlateSelect} value={isNewPlate ? "__new__" : plate} style={inputStyle}>
        <option value="__new__">Yeni Plaka Ekle</option>
        {existingPlates.map((p) => (
          <option key={p.id} value={p.plate}>{p.plate}</option>
        ))}
      </select>
      {isNewPlate && (
        <input placeholder="Yeni Plaka Girin" value={plate} onChange={(e) => setPlate(e.target.value.toUpperCase().replace(/\s+/g, ""))} style={inputStyle} />
      )}
      <input placeholder="Araç Cinsi" value={type} onChange={(e) => setType(e.target.value)} style={inputStyle} />
      <input placeholder="Model" value={model} onChange={(e) => setModel(e.target.value)} style={inputStyle} />
      <input placeholder="Tesis" value={facility} onChange={(e) => setFacility(e.target.value)} style={inputStyle} />
      <input placeholder="Açıklama" value={aciklama} onChange={(e) => setAciklama(e.target.value)} style={inputStyle} />
      <button onClick={handleAddOrUpdatePlate} style={buttonStyle}>Kaydet</button>
      <button onClick={handleExportPlatesToExcel} style={{ ...buttonStyle, backgroundColor: "#22c55e" }}>📤 Plakaları Excel'e Aktar</button>
      <button onClick={handleExportFirmsToExcel} style={{ ...buttonStyle, backgroundColor: "#16a34a" }}>📤 Firmaları Excel'e Aktar</button>

      {authEmail === "c.caliskan@inosel.com.tr" && (
        <div style={{ marginTop: 40 }}>
          <h2>🧨 Tüm Giriş Kayıtlarını Sil</h2>
          <button onClick={handleDeleteAllLogins} style={{ ...buttonStyle, backgroundColor: "#dc2626" }}>Tüm Logları Temizle</button>
        </div>
      )}

      {message && <p style={{ marginTop: 20, color: message.includes("✅") ? "green" : "red" }}>{message}</p>}
    </div>
  );
};

const inputStyle = {
  display: "block",
  margin: "10px 0",
  padding: "8px",
  width: "100%",
  maxWidth: "100%",
  fontSize: "1rem"
};

const buttonStyle = {
  padding: "10px 20px",
  marginTop: 10,
  backgroundColor: "#1e40af",
  color: "white",
  border: "none",
  borderRadius: 4,
  cursor: "pointer"
};

export default AdminPage;
